import { createRouter, createWebHistory } from "vue-router";
import FIApps from "@/views/FIApps.vue";
import LoginPageConsole from "@/views/LoginPageConsole.vue";
import LoginPageCorp from "@/views/LoginPageCorp.vue";
import LoginPageDeveloper from "@/views/LoginPageDeveloper.vue";
import SelectLogin from "@/components/SelectLogin.vue";
import FISearch from "@/views/FISearch.vue";
import EventHistory from "@/views/EventHistory.vue";
import ErrorOut from "@/views/ErrorOut.vue";
import AppCredentials from "@/views/AppCredentials.vue";
import AppModules from "@/views/AppModules.vue";
import BuildImages from "@/views/BuildImages.vue";
import BuildJobs from "@/views/BuildJobs.vue";
import EditConfiguration from "@/views/EditConfiguration.vue";
import MultiBuild from "@/views/MultiBuild.vue";
import ShareableDownload from "@/views/ShareableDownload.vue";

import { useFiStore } from "@/stores/buildStores";
import { useAuthStore } from "@/stores/authStore";
import { logger } from "@/utils/logger";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: SelectLogin,
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();

      if (authStore.checkSession()) {
        if (authStore.isInternalUser()) {
          next({ path: "/fi-search" });
        } else if (authStore.allowedFis.length > 0) {
          next({ name: "FIAppsDynamic", params: { fiNumber: authStore.allowedFis[0].fiNumber } });
        } else {
          next();
        }
      } else {
        next();
      }
    },
    meta: { requiresAuth: false },
  },
  {
    path: "/console/login",
    name: "LoginConsole",
    component: LoginPageConsole,
    meta: { requiresAuth: false },
  },
  {
    path: "/corp/login",
    name: "LoginCorp",
    component: LoginPageCorp,
    meta: { requiresAuth: false },
  },
  {
    path: "/developer/login",
    name: "LoginDeveloper",
    component: LoginPageDeveloper,
    meta: { requiresAuth: false },
  },
  {
    path: "/error",
    name: "ErrorOut",
    component: ErrorOut,
    meta: { requiresAuth: false },
  },
  {
    path: "/fi-search",
    name: "GetFInumber",
    component: FISearch,
    meta: { requiresAuth: true },
  },
  {
    path: "/credentials",
    name: "AppCredentials",
    component: AppCredentials,
    meta: { requiresAuth: true },
  },
  {
    path: "/modules",
    name: "AppModules",
    component: AppModules,
    meta: { requiresAuth: true },
  },
  {
    path: "/build-images",
    name: "BuildImages",
    component: BuildImages,
    meta: { requiresAuth: true },
  },
  {
    path: "/edit-configuration/:configId",
    name: "EditConfiguration",
    component: EditConfiguration,
    meta: { requiresAuth: true },
  },
  {
    path: "/build-jobs",
    name: "BuildJobs",
    component: BuildJobs,
    meta: { requiresAuth: true },
  },
  {
    path: "/multi-build",
    name: "MultiBuild",
    component: MultiBuild,
    meta: { requiresAuth: true },
  },
  {
    path: "/events",
    name: "Events",
    component: EventHistory,
    meta: { requiresAuth: true },
  },
  {
    path: "/apps/:fiNumber/:configId?/:buildId?",
    name: "FIAppsDynamic",
    component: FIApps,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      logger.debug("🌐 Full Route Path:", to.fullPath);
      const fiStore = useFiStore();

      const requestedFiNumber = to.params.fiNumber || to.query.fiNumber;

      logger.debug("🔍 Route Params:", {
        fiNumber: to.params.fiNumber,
        configId: to.params.configId,
        buildId: to.params.buildId,
      });

      logger.debug("🔎 FI Store Before Assignment:", {
        configId: fiStore.configId,
        buildId: fiStore.buildId,
      });

      if (to.params.configId || to.params.buildId) {
        fiStore.setConfigId(to.params.configId || "");
        fiStore.setBuildId(to.params.buildId || "");

        logger.debug(
          "💾 THIS IS WHATS IN FISTORE:",
          fiStore.getConfigId(),
          fiStore.getBuildId()
        );
      }

      try {
        if (requestedFiNumber) {
          fiStore.setFiNumber(requestedFiNumber);
          logger.debug("Loading from FI number");
          await fiStore.loadFiDataFromAPI(requestedFiNumber);
        } else {
          router.push({
            path: '/error'
          });
        }
      } catch (err) {
        console.error("❌ Error loading FI data:", err);

        router.push({
          path: '/error'
        });
      }

      next();
    },
  },
  {
    path: "/s/:fiNumber/:shortKey",
    name: "ShareableDownload",
    component: ShareableDownload,
    meta: { requiresAuth: false },
  },
  {
    path: "/:fiNumber(\\d+)",
    name: "oldRedirect",
    beforeEnter: (to) => {
      const fiNumber = to.params?.fiNumber;

      router.push({
        name: "FIAppsDynamic",
        params: {
          fiNumber: fiNumber,
        },
      });
    },
    meta: { requiresAuth: false },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();

  if (!authStore.checkSession()) {
    try {
      await authStore.authenticate();
      if (authStore.checkSession()) {
        authStore.startHeartbeat();
      }
    } catch (err) {
      console.error("❌ Error during authentication:", err);
    }
  }

if (to.meta.requiresAuth && !authStore.checkSession()) {
    logger.debug("auth store did not authenticate user");
    return { path: "/login", query: { redirect: to.fullPath } };
  }

  return true;
});

export default router;
